import { atom } from 'recoil';
import { CampaignInfoResponse } from '@/types/api/mypage/campaignInfo';

/**
 * キャンペーン情報取得APIの結果を保持する state。
 * キャッシュバック一覧と通常キャンペーン一覧を同じレスポンス形で画面へ供給する。
 */
export const CampaignInfoState = atom<CampaignInfoResponse>({
  key: 'CampaignInfoState',
  default: {
    is_customer_campaign: false,
    cashback_list: [],
    campaigns: [],
  },
});

export default CampaignInfoState;
